/**
 * Central SEO copy for public pages (Barrie local bakery keywords).
 * Used with applySeo() — keeps titles/descriptions consistent and on-brand.
 */

export const SITE_ORIGIN = 'https://nannybbakery.ca';

/** Default OG image when a page has no custom hero (storefront photo). */
export const DEFAULT_OG_IMAGE = '/assets/images/exterior/storefront-exterior.webp';

/** Live homepage. Keep in sync with backend/lib/seoDefaults.js HOME_SEO. */
export const HOME_SEO = {
  title: "Nanny B's Bakery | Custom Cakes & Fresh Pastries in Barrie, ON",
  description:
    'Visit Nanny B\'s Bakery in Barrie, Ontario for delicious custom cakes, fresh pastries, and baked goods. Specializing in birthday cakes, wedding cakes, and special occasion treats. Order online or visit us today!',
  canonicalPath: '/',
  keywords:
    "bakery Barrie, custom cakes Barrie, birthday cakes Barrie, wedding cakes Barrie, fresh pastries Barrie, bakery Ontario, Nanny B's Bakery",
} as const;

export const PAGE_SEO = {
  menu: {
    title: "Menu | Custom Cakes & Fresh Pastries | Nanny B's Bakery Barrie",
    description:
      "Browse our full bakery menu in Barrie, ON — custom cakes, stuffed cookies, cheesecakes, butter tarts, and daily fresh treats. Order online for pickup at Commerce Park Drive.",
    canonicalPath: '/menu',
    keywords:
      'bakery menu Barrie, custom cakes Barrie, order bakery online Barrie, pastries Barrie, stuffed cookies Barrie',
  },
  about: {
    title: "About Us | Nanny B's Bakery — Barrie's Home for Custom Cakes",
    description:
      "Meet Nanny B's Bakery in Barrie, Ontario. Family-owned bakery specializing in custom cakes, fresh pastries, and treats made with love for birthdays, weddings, and every celebration.",
    canonicalPath: '/about',
    keywords: "about Nanny B's Bakery, bakery Barrie Ontario, custom cake bakery Barrie, local bakery Barrie",
  },
  contact: {
    title: "Contact & Hours | Nanny B's Bakery — Barrie, ON",
    description:
      "Visit or contact Nanny B's Bakery at 62 Commerce Park Drive, Unit L, Barrie. Call (705) 503-4966. Hours: Tue–Fri 11am–4:30pm, Sat 10am–3pm. Custom cake orders welcome.",
    canonicalPath: '/contact',
    keywords:
      'Nanny B bakery contact, bakery hours Barrie, bakery address Barrie, custom cake order Barrie phone',
  },
  gallery: {
    title: "Gallery | Custom Cakes & Creations | Nanny B's Bakery Barrie",
    description:
      "See real photos of custom cakes, wedding cakes, birthday cakes, and fresh treats from Nanny B's Bakery in Barrie, Ontario. Inspiration for your next celebration or special order.",
    canonicalPath: '/gallery',
    keywords:
      'bakery gallery Barrie, custom cake photos Barrie, wedding cake Barrie, birthday cake ideas Barrie',
  },
  order: {
    title: "Order Online | Nanny B's Bakery — Pickup in Barrie, ON",
    description:
      "Order fresh bakery treats online from Nanny B's Bakery in Barrie. Custom cakes require 72 hours notice. Secure checkout and pickup at our Commerce Park location.",
    canonicalPath: '/order',
    keywords:
      'order bakery online Barrie, Nanny B bakery order, custom cake order Barrie, bakery pickup Barrie',
  },
  guides: {
    title: "Bakery Guides & Tips | Nanny B's Bakery Barrie",
    description:
      "Helpful guides on custom cakes, ordering timelines, and celebration planning from Nanny B's Bakery in Barrie, Ontario. Local tips for birthdays, weddings, and seasonal treats.",
    canonicalPath: '/guides',
    keywords:
      'custom cake guide Barrie, bakery tips Barrie, how to order custom cake Barrie, Nanny B bakery guides',
  },
  events: {
    title: "Events & Classes | Nanny B's Bakery Barrie",
    description:
      "Join cake decorating classes, birthday parties, and in-store events at Nanny B's Bakery in Barrie. View the schedule, reserve your spot, and learn hands-on decorating skills.",
    canonicalPath: '/events',
    keywords:
      'cake decorating class Barrie, bakery events Barrie, kids baking class Barrie, Nanny B bakery events',
  },
  bakeryInBarrie: {
    title: "Bakery in Barrie | Nanny B's Bakery — Custom Cakes & Pickup",
    description:
      "Looking for a bakery in Barrie? Nanny B's Bakery at 62 Commerce Park Drive, Unit L bakes custom cakes, stuffed cookies, and fresh treats. Call (705) 503-4966. Pickup Tue–Sat.",
    canonicalPath: '/bakery-in-barrie',
    keywords:
      'bakery in Barrie, bakeries in Barrie, Barrie bakery, custom cakes Barrie, bakery near me Barrie, Nanny B bakery Commerce Park',
  },
  pickupAndReturns: {
    title: "Pickup and Returns | Nanny B's Bakery — Barrie, ON",
    description:
      "Pickup and returns at Nanny B's Bakery in Barrie. Website checkout is pickup only at Commerce Park. We do not ship. Contact us about a refund if one applies.",
    canonicalPath: '/pickup-and-returns',
    keywords: 'bakery pickup Barrie, bakery returns Barrie, Nanny B bakery pickup policy',
  },
  cakeRequest: {
    title: "Custom Cake Request | Nanny B's Bakery Barrie",
    description:
      "Request a custom cake from Nanny B's Bakery in Barrie. Choose size, flavour, and filling. Tammy will quote you. 72 hours notice. Pickup at Commerce Park.",
    canonicalPath: '/cake-request',
    keywords:
      'custom cake request Barrie, cake order form Barrie, custom cake Barrie, Nanny B bakery cake',
  },
} as const;
